import { Box } from '@mui/material'
import { PADDING_BASE } from '../../assets/Styles'
import TitlebarAction from '../../components/common/TitlebarActions'
import TopSideBar from '../../components/TopSideBar'
import PageContainer from '../../components/common/PageContainer'
import Breadcrumbs from '../../components/common/Breadcrumbs'
import { Link } from 'react-router-dom'
import CompanyCreate from '../../components/CompanyCreate'
import { useProject } from '../../context/ProjectContext'

export default function CompanyCreatePage({ setBlockScreen }: any) {

  const { isProjectUndefined } = useProject()

  return (<>
    <TopSideBar currentSection='companies' disableProjectSelector />

    <PageContainer>

      <Box paddingBottom={PADDING_BASE}>
        <Breadcrumbs pathlist={[
          <Link className='breadcrumbs-nav__link' to="/tickets/listing">
            Home
          </Link>,
          <Link className='breadcrumbs-nav__link' to="/companies/listing">
            Compañías
          </Link>,
          'Nueva']}
        />
      </Box>

      <TitlebarAction
        title='Nueva Compañía'
      />

      {!isProjectUndefined() && (
        <CompanyCreate
          setBlockScreen={setBlockScreen}
        />)}
    </PageContainer>
  </>)
}